import { inject, observer } from "mobx-react";
import { useEffect, useReducer, useRef, useState } from "react";
import "./applications.scss";

import cross from "images/cross.svg";
import iconAttention from "images/iconAttention.svg";
import search from "../images/search.svg";

import Filter from "sharedComponents/Filter";

import { ReactComponent as IconSort } from "images/iconArrowDouble.svg";
import { ReactComponent as IconTopArrow } from "images/topArrow.svg";
import { Form } from "react-bootstrap";
import { FIO, setTimeCreate } from "utils/functions";

// Статусы, в которых агент может обновить отклик (согласовано с заказчиком)
const UPDATABLE_STATUS_TITLES = [
  "Довнести данные кандидата",
  "Записан на трудоустройство"
];

const getPhone = function (phone) {
  return phone
    ? `+${phone.charAt(0)} (${phone.substring(1, 4)}) ${phone.substring(
        4,
        7
      )}-${phone.substring(7, 9)}-${phone.substring(9, 11)}`
    : "";
};

const Applications = ({
  applications,
  applicationsCountAll,
  applicationsStatuses,
  getApplications,
  setCandidateSurname,
  candidateSurname,
  education_centers,
  showMoreApplications,
  cleanApplications,
  startApplicationUpdate,

  errorMessage,

  setSort,
  setSorted,

  isLoading,

  vacanciesObj,
  setFilter,

  prevRes,
  setPrevRes,

  setSelectedCandidate,
  getOneCandidate,
  setIsCandidateModalOpen,
  cleanErrorAddition,
  setIsNewCandidate
}) => {
  // Обновление отклика доступно только в согласованных статусах
  const canUpdateApplication = (candidate) => {
    const title =
      applicationsStatuses && applicationsStatuses[candidate.status_id]
        ? applicationsStatuses[candidate.status_id].title
        : "";
    return UPDATABLE_STATUS_TITLES.includes(title);
  };

  const listInnerRef = useRef();
  const [searchFocused, setSearchFocused] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [checked, setChecked] = useState({
    applicationsStatuses: null,
    education_centers: null,
    vacancies: null
  });
  const hasValues = Object.values(checked).some((val) => val);
  const names = Object.keys(checked);

  const onScroll = async () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (
        scrollTop + clientHeight === scrollHeight &&
        applicationsCountAll != applications.length
      ) {
        if (prevRes !== -1) {
          await showMoreApplications();
        }
      }
    }
  };

  const getSortedData = async (sort, sorted) => {
    cleanApplications();
    setSort(sort);
    setSorted(sorted);
    await getApplications();
  };

  const setDefaultData = () => {
    setPrevRes(1);
    // по умолчанию сверху обновлённые отклики
    setSort("last_update");
    setSorted("desc");
    for (const prop in checked) {
      setFilter(prop, []);
    }
  };

  const setUncheckedObj = () => {
    cleanApplications();
    const arr = [applicationsStatuses, vacanciesObj, education_centers];
    let obj = {};

    for (let i = 0; i < arr.length; i++) {
      let unchecked = {};
      for (const prop in arr[i]) {
        unchecked[prop] = false;
      }
      obj[names[i]] = unchecked;
    }
    setChecked(obj);
  };

  useEffect(() => {
    cleanApplications();
    setUncheckedObj();
    setDefaultData();
    return () => {
      setDefaultData();
      cleanApplications();
    };
  }, []);

  useEffect(() => {
    errorMessage && cleanApplications();
  }, [errorMessage]);

  useEffect(() => {
    applicationsStatuses && setSelectedFilter(applicationsStatuses);
  }, [applicationsStatuses]);

  const initialCount = {
    date_create: 0,
    date_arrival: 0
  };

  const reducer = (state, action) => {
    switch (action) {
      case "date_create": {
        return {
          date_create: state.date_create !== 2 ? state.date_create + 1 : 0,
          date_arrival: 0
        };
      }
      case "date_arrival": {
        return {
          date_arrival: state.date_arrival !== 2 ? state.date_arrival + 1 : 0,
          date_create: 0
        };
      }
      default:
        return initialCount;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialCount);

  useEffect(() => {
    for (const prop in state) {
      state[prop] === 1 && getSortedData(prop, "asc");
      state[prop] === 2 && getSortedData(prop, "desc");
    }
  }, [state]);

  const handleFilter = async () => {
    setPrevRes(1);
    for (const prop in checked) {
      if (checked[prop]) {
        let array = [];
        for (const key of Object.keys(checked[prop])) {
          checked[prop][key] && array.push(key);
        }
        setFilter(prop, array);
      } else {
        setFilter(prop, []);
      }
    }
    await getApplications();
  };

  useEffect(() => {
    if (Object.values(checked).some((val) => !!val)) {
      handleFilter();
    }
  }, [checked]);

  const handleSearch = (e) => {
    setCandidateSurname(e.target.value);
    setTimeout(() => {
      getApplications();
    }, 500);
  };

  return (
    <div className="applications">
      <div className="applications__header">
        <div className="applications__search">
          <div className="position-relative w-100">
            <input
              className="flex-grow-1"
              placeholder="Поиск по кандидатам"
              onChange={handleSearch}
              onFocus={() => setSearchFocused(true)}
              value={candidateSurname}
              onBlur={() => setTimeout(() => setSearchFocused(false), 200)}
            />
            {searchFocused ? (
              <img
                className="icon-clear"
                src={cross}
                alt="clear"
                onClick={async () => {
                  setPrevRes(1);
                  if (candidateSurname) {
                    setCandidateSurname("");
                    getApplications();
                  }
                  setSearchFocused(false);
                }}
              />
            ) : null}
          </div>
          <button
            className="applications__btn applications__btn_search"
            onClick={() => candidateSurname && getApplications()}
          >
            <img src={search} alt="search" />
          </button>
        </div>
        <div className="applications__search applications__search-mobile flex-grow-1">
          {searchFocused || candidateSurname ? (
            <div className="w-100">
              <input
                placeholder="Поиск по кандидатам"
                onChange={handleSearch}
                onFocus={() => setSearchFocused(true)}
                value={candidateSurname}
                onBlur={() => setTimeout(() => setSearchFocused(false), 200)}
              />
              <img
                className="icon-clear"
                src={cross}
                alt="clear"
                onClick={() => {
                  setPrevRes(1);
                  if (candidateSurname) {
                    setCandidateSurname("");
                    getApplications();
                  }
                  setSearchFocused(false);
                }}
              />
            </div>
          ) : (
            <button
              className="applications__btn applications__btn_search-mobile"
              onClick={() => setSearchFocused(true)}
            >
              <img src={search} alt="search" />
            </button>
          )}
        </div>

        <Filter
          title={
            selectedFilter === applicationsStatuses
              ? "Статус"
              : selectedFilter === education_centers
              ? "УЦ"
              : "Вакансии"
          }
          numOfFilters={() => {
            let num = [];
            if (hasValues) {
              const arr = Object.values(checked).filter(Boolean);
              for (const i of arr) {
                num = [...num, ...Object.values(i).filter((val) => val)];
              }
            }
            return num.length;
          }}
          handleFilter={() => {
            setPrevRes(-1);
            setUncheckedObj();
          }}
        >
          <ul>
            {selectedFilter
              ? Object.keys(selectedFilter).map((key) => {
                  const name =
                    selectedFilter === vacanciesObj
                      ? "vacancies"
                      : selectedFilter === education_centers
                      ? "education_centers"
                      : "applicationsStatuses";
                  return (
                    <li key={key} className="d-flex gap-2">
                      <Form.Check
                        id={key}
                        name={key}
                        onChange={(e) => {
                          if (!checked[name]) {
                            setChecked({
                              ...checked,
                              [name]: {}
                            });
                            setChecked({
                              ...checked,
                              [name]: {
                                ...checked[name],
                                [key]: e.target.checked
                              }
                            });
                          } else {
                            setChecked({
                              ...checked,
                              [name]: {
                                ...checked[name],
                                [key]: e.target.checked
                              }
                            });
                          }
                        }}
                        checked={!!checked[name][key]}
                      />

                      <div>{checked[name][key]}</div>
                      <Form.Label className="m-0" htmlFor={key}>
                        {selectedFilter[key]["title"]
                          ? selectedFilter[key]["title"]
                          : selectedFilter[key]["position_id_title"]}
                      </Form.Label>
                    </li>
                  );
                })
              : null}
          </ul>
          <ul>
            <li
              onClick={() => setSelectedFilter(vacanciesObj)}
              className={selectedFilter === vacanciesObj ? "item-selected" : ""}
            >
              Вакансии
              {checked.vacancies &&
              Object.values(checked.vacancies).filter((val) => val).length >
                0 ? (
                <span className="filter-num">
                  {Object.values(checked.vacancies).filter((val) => val).length}
                </span>
              ) : null}
            </li>
            <li
              onClick={() => setSelectedFilter(education_centers)}
              className={
                selectedFilter === education_centers ? "item-selected" : ""
              }
            >
              Учебный центр
              {checked.education_centers &&
              Object.values(checked.education_centers).filter((val) => val)
                .length > 0 ? (
                <span className="filter-num">
                  {
                    Object.values(checked.education_centers).filter(
                      (val) => val
                    ).length
                  }
                </span>
              ) : null}
            </li>
            <li
              onClick={() => setSelectedFilter(applicationsStatuses)}
              className={
                selectedFilter === applicationsStatuses ? "item-selected" : ""
              }
            >
              Статус отклика
              {checked.applicationsStatuses &&
              Object.values(checked.applicationsStatuses).filter((val) => val)
                .length > 0 ? (
                <span className="filter-num">
                  {
                    Object.values(checked.applicationsStatuses).filter(
                      (val) => val
                    ).length
                  }
                </span>
              ) : null}
            </li>
          </ul>
        </Filter>

        <div className="w-100 text-center applications__btns-mobile mt-2">
          <button
            onClick={() => dispatch("date_create")}
            className="applications__btn applications__btn-sort me-2"
          >
            Дата создания
            <IconSort
              className={`icon-sort ${
                state.date_create === 1
                  ? "icon-sort_desc"
                  : state.date_create === 2
                  ? "icon-sort_asc"
                  : ""
              }`}
              alt="sort"
            />
          </button>
          <button
            onClick={() => dispatch("date_arrival")}
            className="applications__btn applications__btn-sort"
          >
            Дата прибытия
            <IconSort
              className={`icon-sort ${
                state.date_arrival === 1
                  ? "icon-sort_desc"
                  : state.date_arrival === 2
                  ? "icon-sort_asc"
                  : ""
              }`}
              alt="sort"
            />
          </button>
        </div>
      </div>

      <div
        className="applications-table-container"
        onScroll={onScroll}
        ref={listInnerRef}
      >
        <table className="applications-table w-100">
          <thead>
            <tr>
              <th>
                <p className="m-0">Кандидат</p>
              </th>
              <th>
                <p
                  className="m-0 sort-btn"
                  onClick={() => dispatch("date_create")}
                >
                  Дата создания
                  <IconSort
                    className={`icon-sort ${
                      state.date_create === 1
                        ? "icon-sort_desc"
                        : state.date_create === 2
                        ? "icon-sort_asc"
                        : ""
                    }`}
                    alt="sort"
                  />
                </p>
              </th>
              <th>
                <p className="m-0">Регион проживания</p>
              </th>
              <th>
                <p className="m-0">Номер телефона</p>
              </th>
              <th>
                <p className="m-0">Вакансия</p>
              </th>
              <th>
                <p className="m-0">Учебный центр</p>
              </th>
              <th>
                <p
                  className="m-0 sort-btn"
                  onClick={() => dispatch("date_arrival")}
                >
                  Дата прибытия
                  <IconSort
                    className={`icon-sort ${
                      state.date_arrival === 1
                        ? "icon-sort_desc"
                        : state.date_arrival === 2
                        ? "icon-sort_asc"
                        : ""
                    }`}
                    alt="sort"
                  />
                </p>
              </th>
              <th>
                <p className="m-0 status_id">Статус</p>
              </th>
              <th>
                <p>Дата отклика</p>
              </th>
              {/* Вознаграждение скрыто в задаче FRONT-843 */}
              {/* <th>
                <p className="m-0">Вознаграждение</p>
              </th> */}
              <th>
                <p className="m-0">Комментарий</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {applications && applications.length
              ? applications.map((candidate) => {
                  return (
                    <tr key={candidate.vacancy_candidate_id}>
                      <td
                        onClick={async () => {
                          setSelectedCandidate(candidate.candidate_id);
                          cleanErrorAddition();
                          await getOneCandidate(candidate.candidate_id);
                          setIsCandidateModalOpen(true);
                          setIsNewCandidate(false);
                        }}
                      >
                        <p className="m-0">{FIO(candidate, true)}</p>
                      </td>
                      <td>
                        <p className="m-0">
                          {setTimeCreate(candidate.date_create)}
                        </p>
                      </td>
                      <td>
                        <p className="m-0">{candidate.region_of_residence}</p>
                      </td>
                      <td>
                        <p className="m-0 phone-num">
                          {getPhone(candidate.phone)}
                        </p>
                      </td>
                      <td>
                        <p className="m-0">{candidate.vacancy_title}</p>
                      </td>
                      <td>
                        <p className="m-0">
                          {candidate.education_center_title}
                        </p>
                      </td>
                      <td>
                        <p className="m-0">
                          {candidate.date_arrival &&
                            candidate.date_arrival
                              .split("-")
                              .reverse()
                              .join(".")}
                        </p>
                      </td>
                      <td className="status_id">
                        <div className="d-flex align-items-center">
                          <p className="m-0">
                            {applicationsStatuses
                              ? applicationsStatuses[candidate.status_id].title
                              : ""}
                          </p>
                          {candidate.comment ? (
                            <img src={iconAttention} alt="" />
                          ) : null}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          <p>{setTimeCreate(candidate.last_update)}</p>
                          {canUpdateApplication(candidate) && (
                            <button
                              onClick={() => startApplicationUpdate(candidate)}
                              className="update-btn"
                              title="Обновить отклик — поднять в топ списка для менеджеров"
                            >
                              <span className="update-btn_text">
                                Обновить отклик
                              </span>
                              <IconTopArrow />
                            </button>
                          )}
                        </div>
                      </td>
                      {/* Вознаграждение скрыто в задаче FRONT-843 */}
                      {/* <td>
                        <p className="m-0">{candidate.agent_wages} руб.</p>
                      </td> */}
                      <td>
                        <p className="m-0">{candidate.comment}</p>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>

        <div className="applications-table_small">
          {applications && applications.length
            ? applications.map((candidate) => {
                return (
                  <div
                    key={candidate.vacancy_candidate_id}
                    className="application-card"
                  >
                    <ul>
                      <li>
                        <span>Кандидат:</span>
                        <span
                          className="application-card__fio"
                          onClick={async () => {
                            setSelectedCandidate(candidate.candidate_id);
                            cleanErrorAddition();
                            await getOneCandidate(candidate.candidate_id);
                            setIsCandidateModalOpen(true);
                            setIsNewCandidate(false);
                          }}
                        >
                          {FIO(candidate, true)}
                        </span>
                      </li>
                      <li>
                        <span>Дата создания кандидата:</span>
                        {setTimeCreate(candidate.date_create)}
                      </li>
                      <li>
                        <span>Регион проживания:</span>
                        {candidate.region_of_residence}
                      </li>
                      <li className="phone-num">
                        <span>Телефон:</span>
                        <a href={`tel:${getPhone(candidate.phone)}`}>
                          {getPhone(candidate.phone)}
                        </a>
                      </li>
                      <li>
                        <span>Вакансия:</span>
                        {candidate.vacancy_title}
                      </li>
                      <li>
                        <span>Учебный центр:</span>
                        {candidate.education_center_title}
                      </li>
                      <li>
                        <span>Дата прибытия:</span>
                        {candidate.date_arrival &&
                          candidate.date_arrival.split("-").reverse().join(".")}
                      </li>
                      <li>
                        <span>Статус:</span>
                        {applicationsStatuses
                          ? applicationsStatuses[candidate.status_id].title
                          : ""}
                        {candidate.comment ? (
                          <img src={iconAttention} alt="" />
                        ) : null}
                      </li>
                      <li>
                        <span>Дата отклика</span>
                        <p>{setTimeCreate(candidate.last_update)}</p>
                        {canUpdateApplication(candidate) && (
                          <button
                            onClick={() => startApplicationUpdate(candidate)}
                            className="update-btn"
                            title="Обновить отклик — поднять в топ списка для менеджеров"
                          >
                            <span className="update-btn_text">
                              Обновить отклик
                            </span>
                            <IconTopArrow />
                          </button>
                        )}
                      </li>
                      {/* Вознаграждение скрыто в задаче FRONT-1264 */}
                      {/* <li>
                        <span>Вознаграждение:</span>
                        {candidate.agent_wages} руб.
                      </li> */}
                      <li>
                        <span>Комментарий:</span>
                        {candidate.comment}
                      </li>
                    </ul>
                  </div>
                );
              })
            : null}
        </div>
        {isLoading ? (
          <div className="w-100 mt-2 candidatesmap-info text-center">
            Пожалуйста, подождите...
          </div>
        ) : null}
        {errorMessage ? (
          <div className="w-100 mt-3 candidatesmap-info text-center">
            {errorMessage}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default inject(({ candidatesStore, vacanciesStore, modalWindows }) => {
  const {
    applications,
    applicationsCountAll,
    showMoreApplications,
    applicationsStatuses,
    getApplications,
    setSelectedCandidate,
    setCandidateSurname,
    setCandidateStatusesInStore,
    candidateStatusesInStore,
    candidateStatusesNames,
    candidateSurname,
    education_centers,
    cleanApplications,
    errorMessage,
    getOneCandidate,
    startApplicationUpdate,

    setSort,
    setSorted,

    isLoading,
    setFilter,

    prevRes,
    setPrevRes,
    cleanErrorAddition,
    setIsNewCandidate
  } = candidatesStore;

  const { vacanciesObj } = vacanciesStore;

  const {
    setAddNewCandidateModal,
    addNewCandidateModal,
    setIsCandidateModalOpen
  } = modalWindows;

  return {
    applications,
    applicationsCountAll,
    showMoreApplications,
    errorMessage,
    applicationsStatuses,
    getApplications,
    setCandidateSurname,
    candidateSurname,
    setSelectedCandidate,
    setCandidateStatusesInStore,
    candidateStatusesInStore,
    candidateStatusesNames,
    education_centers,
    cleanApplications,
    getOneCandidate,
    startApplicationUpdate,

    setSort,
    setSorted,

    isLoading,

    vacanciesObj,
    setFilter,

    setAddNewCandidateModal,
    addNewCandidateModal,

    prevRes,
    setPrevRes,
    setIsCandidateModalOpen,
    cleanErrorAddition,
    setIsNewCandidate
  };
})(observer(Applications));
